import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { PopupComponent } from 'src/app/components/builders/popup/popup.component';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-broker-create-dialog',
  templateUrl: './broker-create-dialog.component.html',
  styleUrls: ['./broker-create-dialog.component.scss']
})
export class BrokerCreateDialogComponent implements OnInit {

  @ViewChild('basicModal') public modalComponent: any;
  fileName: string = 'No file selected';
  imageUrl: string | ArrayBuffer;
  tempUrlImg: any;
  _fileCount: any = 0;
  files: any[] = [];
  brokerForm: FormGroup;
  countryArray: any = [];
  LoaderComponent: any;
  settlementCommission: any[] = [];
  registrationCommission: any[] = [];
  responseMessage: any;
  profileIcon: any;
  deleteIcon: string;
  title: string;
  isUploading: any = false;
  fileType: any;
  brokerImage: string = '';
  brokerFile: string = '';
  @ViewChild('successModal') successModal: any;
  countryDropdownSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; closeDropDownOnSelection: boolean; };
  settlementDropDownSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; closeDropDownOnSelection: boolean; };
  constructor(
    public dialogRef: MatDialogRef<BrokerCreateDialogComponent>,
    private fb: FormBuilder,
    public service: WebRequestService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.title = data ? 'Update Broker' : 'Create Broker';
    this.brokerForm = this.fb.group({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      mobileNumber: new FormControl('', [Validators.required, Validators.minLength(10)]),
      areaCode: new FormControl(''),
      countryCode: new FormControl(''),
      landlineNumber: new FormControl(''),
      contactAddress: new FormControl(''),
      settlementCommission: new FormControl(''),
      registrationCommission: new FormControl('')
    });

    this.countryDropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'countryCode',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };

    this.settlementDropDownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };
  }

  ngOnInit(): void {
    this.service
    .countryCodeData('CountryCode')
    .then((response) => {
      this.countryArray = response['result'];
      if (this.data) {
        this.brokerForm.patchValue({
          countryCode: this.data.broker.countryCode != null ? [this.getCountry(this.data.broker.countryCode)] : '',
        })
      }
    })

    this.service.loadMasterData('BrokarageCommisions').then((res) => {
      if(res['statusCode'] === 200){
        console.log(res);
        this.settlementCommission = res['result'];
        this.registrationCommission = res['result']
      }
    });

    if (this.data) {
      this.patchBrokerDetails();
      this.brokerImage = this.data.broker.fileImagePath ? this.data.broker.fileImagePath : '';
      this.brokerFile = this.data.broker.fileDocPath ? this.data.broker.fileDocPath : '';
    }

    this.deleteIcon = '../../../assets/img/dashboard/delete_ic.svg';
    this.profileIcon = '../../../assets/img/dashboard/profie_pic.svg';
  }

  patchBrokerDetails() {
    console.log(this.data);
    this.brokerForm.patchValue({
      name: this.data.broker.name,
      email: this.data.broker.email,
      mobileNumber: this.data.broker.mobileNumber,
      areaCode: this.data.broker.areaCode,
      // countryCode: this.data.broker.countryCode != null ? [this.getCountry(this.data.broker.countryCode)] : '',
      landlineNumber: this.data.broker.landlineNumber,
      contactAddress: this.data.broker.contactAddress,
      settlementCommission: this.data.broker.settlementCommission ? [{id : this.data.broker.settlementCommissionID, value: JSON.stringify(this.data.broker.settlementCommission)}] : '',
      registrationCommission: this.data.broker.registrationCommission ? [{id : this.data.broker.registrationCommissionID, value: JSON.stringify(this.data.broker.registrationCommission)}] : ''
    })
  }

  onNoClick(){
    this.dialogRef.close(true);
  }

  getCountry(id) {
    return this.countryArray.find(val => val.id == id)
  }

  omit_specialChar_and_char(event) {
    let x = event.which || event.keycode;
    if ((x >= 48 && x <= 57))
      return true;
    else
      return false;
  }

  createBroker() {
    const data = {
      name: this.brokerForm.value.name,
      email: this.brokerForm.value.email,
      mobileNumber: this.brokerForm.value.mobileNumber,
      areaCode: this.brokerForm.value.areaCode,
      countryCode: this.brokerForm.value.countryCode &&
      this.brokerForm.value.countryCode.length !== 0
      ? this.brokerForm.value.countryCode.length > 1
        ? String(
          this.brokerForm.value.countryCode.map((val) => {
            return String(val.id);
          })
        )
        : String(this.brokerForm.value.countryCode[0].id)
      : null,
      landlineNumber: this.brokerForm.value.landlineNumber,
      contactAddress: this.brokerForm.value.contactAddress,
      settlementCommission:  this.brokerForm.value.settlementCommission &&
      this.brokerForm.value.settlementCommission.length !== 0
      ? this.brokerForm.value.settlementCommission.length > 1
        ? String(
          this.brokerForm.value.settlementCommission.map((val) => {
            return String(val.id);
          })
        )
        : String(this.brokerForm.value.settlementCommission[0].id)
      : null,
      registrationCommission:  this.brokerForm.value.registrationCommission &&
      this.brokerForm.value.registrationCommission.length !== 0
      ? this.brokerForm.value.registrationCommission.length > 1
        ? String(
          this.brokerForm.value.registrationCommission.map((val) => {
            return String(val.id);
          })
        )
        : String(this.brokerForm.value.registrationCommission[0].id)
      : null
    };
    this.LoaderComponent = LoaderComponent;
    this.service.createBroker(data).then((res) => {
      if(res['statusCode'] === 200) {
        this.LoaderComponent = '';
        this.responseMessage = 'Broker Created Successfully';
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
          this.dialogRef.close(true);
        }, 3000);
      } else {
        this.LoaderComponent = '';
        this.responseMessage = res['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
          this.dialogRef.close();
        }, 3000);
      }
    })
  }

  updateBroker() {
    const data = {
      id: this.data.broker.id,
      name: this.brokerForm.value.name,
      email: this.brokerForm.value.email,
      mobileNumber: this.brokerForm.value.mobileNumber,
      areaCode: this.brokerForm.value.areaCode,
      countryCode: this.brokerForm.value.countryCode &&
      this.brokerForm.value.countryCode.length !== 0
      ? this.brokerForm.value.countryCode.length > 1
        ? String(
          this.brokerForm.value.countryCode.map((val) => {
            return String(val.id);
          })
        )
        : String(this.brokerForm.value.countryCode[0].id)
      : null,
      landlineNumber: this.brokerForm.value.landlineNumber,
      contactAddress: this.brokerForm.value.contactAddress,
      settlementCommission:  this.brokerForm.value.settlementCommission &&
      this.brokerForm.value.settlementCommission.length !== 0
      ? this.brokerForm.value.settlementCommission.length > 1
        ? String(
          this.brokerForm.value.settlementCommission.map((val) => {
            return String(val.id);
          })
        )
        : String(this.brokerForm.value.settlementCommission[0].id)
      : null,
      registrationCommission:  this.brokerForm.value.registrationCommission &&
      this.brokerForm.value.registrationCommission.length !== 0
      ? this.brokerForm.value.registrationCommission.length > 1
        ? String(
          this.brokerForm.value.registrationCommission.map((val) => {
            return String(val.id);
          })
        )
        : String(this.brokerForm.value.registrationCommission[0].id)
      : null
    };
    this.LoaderComponent = LoaderComponent;
    this.service.updateBroker(data).then((res) => {
      if(res['statusCode'] === 200) {
        this.LoaderComponent = '';
        this.responseMessage = 'Broker Updated Successfully';
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
          this.dialogRef.close(true);
        }, 3000);
      }
    })
  }

  browsePhoto(fileType) {
    this.fileType = fileType;
    this.modalComponent.show();
  }

  browseFiles() {
    var fileDropbtn = document.getElementById('fileDropRef');
    fileDropbtn.click();
  }

  fileBrowseHandler(files) {
    let supportedImg = ['image/jpeg', 'image/jpg', 'image/gif', 'application/pdf', 'application/doc', 'application/docx'];
    if (files[0].size / (1024 * 1024) > 4) {
      this.successModal = PopupComponent;
      this.data._errorMessage = 'Image size is too large';
      setTimeout(() => {
        this.successModal = '';
      }, 5000);
    } else {
      if (supportedImg.indexOf(files[0].type) === -1) {
        this.successModal = PopupComponent;
        this.data._errorMessage = 'invalid image type';
        setTimeout(() => {
          this.successModal = '';
        }, 5000);
      } else {
        this._fileCount++;
        this.prepareFilesList(files);
      }
    }
  }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      this.fileName = item.name;
      const reader = new FileReader();
      reader.readAsDataURL(item);

      reader.onload = (event) => {
        this.imageUrl = reader.result;
        item['url'] = this.imageUrl;
        this.tempUrlImg = this.imageUrl;
        // this.tempUrlImg.push({ url: this.imageUrl });

        this.files.push(item);
        // this._isFileUpload = true;
      };
    }
  }

  deleteFile(index: number) {
    this._fileCount--;
    this.files.splice(index, 1);
    this.tempUrlImg = '';
  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  uploadProfileImages() {
    const formData = new FormData();
    this.files.map((_f, index) => {
      delete _f.url;
      formData.append('brokerFile', _f);
      formData.append('brokerId', this.data.broker.id);
      formData.append('isImage', this.fileType)
    });
    this.LoaderComponent = LoaderComponent;
    this.isUploading = true;
    // const files = this.files
    this.service.brokerUpdatePhotoORFile(formData).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = '';
        this.files = [];
        this.responseMessage = res['message'];
        this.fileType === 1 ? this.brokerImage = res['result'] : this.brokerFile = res['result'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
          this.tempUrlImg = '';
          this.modalComponent.hide();
        }, 3000);
      } else {
        this.LoaderComponent = '';
        this.responseMessage = res['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 3000);
      }
    })

  }

  deleteImg(fileType) {
    const data = {
      brokerId: this.data.broker.id,
      isImage: fileType,
      keyName: fileType === 1 ? this.brokerImage : this.brokerFile,
    };
    this.LoaderComponent = LoaderComponent;
    this.service.deleteBrokerPhotoORFile(data).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = '';
        this.responseMessage = res['message'];
        this.successModal.show();
        fileType === 1 ? this.brokerImage = '' : this.brokerFile = '';
        setTimeout(() => {
          this.successModal.hide();
        }, 3000);
      } else {
        this.LoaderComponent = '';
        this.responseMessage = res['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 3000);
      }
    })
  }

  closeBasicModal() {
    this.modalComponent.hide();
    this.tempUrlImg = '';
  }

}
